import { TournamentCompetitionDefinition, TournamentCustomGroup, TournamentMatchSource } from 'Src/models/tournament';

const ordinal = (position: number) =>
  `${position}${
    position % 100 >= 11 && position % 100 <= 13
      ? 'th'
      : position % 10 === 1
      ? 'st'
      : position % 10 === 2
      ? 'nd'
      : position % 10 === 3
      ? 'rd'
      : 'th'
  }`;

export function tournamentStructurePublicRoutes(
  definition: TournamentCompetitionDefinition,
  groups: TournamentCustomGroup[]
): TournamentCompetitionDefinition['groupRoutes'] {
  return groups.map(group => {
    const saved = definition.groupRoutes.find(route => route.groupId === group.id);
    if (
      saved &&
      (saved.isAutomatic === false ||
        (saved.isAutomatic === undefined && (saved.publicExplanation || saved.destinations?.length)))
    )
      return saved;
    const destinations = new Map<string, { positions: Set<number>; outcomes: Set<string> }>();
    const add = (targetId: string, source: TournamentMatchSource) => {
      const sourceMatch = definition.matches.find(match => match.id === source.sourceMatchId);
      const applies =
        source.sourceType === 'GROUP_POSITION' ? source.sourceGroupId === group.id : sourceMatch?.groupId === group.id;
      if (!applies || targetId === group.id) return;
      if (!destinations.has(targetId)) destinations.set(targetId, { positions: new Set(), outcomes: new Set() });
      const target = destinations.get(targetId)!;
      if (source.sourceType === 'GROUP_POSITION') target.positions.add(source.sourcePosition!);
      else target.outcomes.add(source.sourceType === 'MATCH_WINNER' ? 'Winners' : 'Losers');
    };
    (definition.qualifierGroups || []).forEach(pool => pool.sources.forEach(source => add(pool.groupId, source)));
    definition.matches
      .filter(match => !match.removed)
      .forEach(match => [match.homeSource, match.awaySource].forEach(source => add(match.groupId, source)));
    const routes = Array.from(destinations.entries())
      .filter(([targetId]) => groups.some(item => item.id === targetId))
      .map(([targetId, details]) => {
        const title = groups.find(item => item.id === targetId)!.name;
        const places = [
          ...Array.from(details.positions)
            .sort((a, b) => a - b)
            .map(ordinal),
          ...Array.from(details.outcomes)
        ].join(', ');
        return { title, places, publicExplanation: `${places} from ${group.name} advance to ${title}.` };
      });
    return {
      groupId: group.id,
      isAutomatic: true,
      publicExplanation: routes.map(route => route.publicExplanation).join(' '),
      destinations: routes
    };
  });
}
